import { useMemo } from "react";
import { SceneAssetProps } from "../types";
import { getAssetComponent } from "../AnimationsWithAssets/utils";

const Asset3D: React.FC<SceneAssetProps> = ({
  asset,
  transform3D,
  animation,
  customMaterials,
}) => {
  // To prevent the component from re-mounting we only recalculate the Asset component when the animation name changes
  const Asset = useMemo(
    () => getAssetComponent(animation?.animation, animation?.interactionType),
    [animation?.name],
  );

  return (
    <Asset
      asset={asset}
      transform3D={transform3D}
      customMaterials={customMaterials}
    />
  );
};

export default Asset3D;
